export const NONE = 'NONE';
export const IN_REVIEW = 'IN_REVIEW';
export const OK = 'OK';
export const BLOCKED = 'BLOCKED';
export const NO_REVIEW = 'NO_REVIEW';
export default {
  NONE,
  IN_REVIEW,
  OK,
  BLOCKED,
  NO_REVIEW
};